import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { QrCodeProps } from "./types";
import { PropertyDefinition } from "app/library/layout-builder"

export class QrCodeDefinitions extends CmsReactComponent<QrCodeProps> {
    static schemaName = "qr-code";

    static propertyDefinitions: PropertyDefinition[] = [];
}
